import React from "react"

export const Vergleich = ({ size = 1 }) => {
  return (
    <svg
      width={94 * size}
      height={84 * size}
      viewBox="0 0 94 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="#E5EDF0" d="M12 0h70v27H12zM12 57h70v27H12z" />
      <path
        d="M33.469 12.5h33.878M26.469 12.5h3"
        stroke="#B3CBD4"
        strokeWidth={3}
      />
      <path fill="#FFD62E" d="M6 26h82v32H6z" />
      <path d="M32 73.5h33.878M25 73.5h3" stroke="#B3CBD4" strokeWidth={3} />
      <path
        d="M33.469 40.01h33.878M26.469 40.01h3M33.469 45.01h33.878M26.469 45.01h3M2 22h90v40H2z"
        stroke="#034055"
        strokeWidth={3}
      />
    </svg>
  )
}
